<template>
    <div style="position:relative">
        <a-button
            class="map-icon-btn"
            @click="() => showSubtitle = !showSubtitle"
            title="Expandir legenda"
            aria-label="Expandir legenda"
            :icon="h(UnorderedListOutlined)"
            v-if="!showSubtitle"
        />

        <div class="legend-container" v-if="showSubtitle">
            <button class="close-btn" @click="() => showSubtitle = !showSubtitle"><i class="fa-solid fa-xmark" /></button>
            <span style="align-self:center; font-weight:bold; font-size:18px">Legenda</span>
            <span style="font-size:16px">{{ props.description }}:</span>
            <img :src="props.src" alt="Imagem de legenda de mapa" />
        </div>
    </div>
</template>

<script setup>
import {h, ref} from "vue";
import {UnorderedListOutlined} from "@ant-design/icons-vue";

const props = defineProps(['description', 'src'])
const showSubtitle = ref(true)
</script>

<style scoped>
.map-icon-btn {
    width: var(--home-map-icon-size, 32px);
    height: var(--home-map-icon-size, 32px);
    border-radius: var(--home-map-icon-radius, 6px);
    background-color: rgba(0, 60, 136, .6);
    color: white;
    border: 2px solid white;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.close-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 20px;
    height: 20px;
    padding: 0;
    border: 0;
    background-color: #FFF;
    transition: all 0.2s;
}

.close-btn:hover {
    background-color: #d2d2d2;
}

.legend-container {
    background-color: #FFF;
    display: flex;
    flex-direction: column;
    padding: 10px;
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
</style>